{
  const initHeader = () => {
    // Mobile header functionality
    const mobileHeaderLists = document.querySelectorAll('.header__menu-link--has-children');
    mobileHeaderLists.forEach(list => {
      list.addEventListener('click', (e) => {
      const parent = e.currentTarget;
      
      if(parent.getAttribute('aria-expanded') === 'true') {
        parent.setAttribute('aria-expanded', false);
        parent.style.maxHeight = '1.5rem'; // Reset to default height
        parent.style.minHeight = '1.5rem';
        return;
      } else if(parent.getAttribute('aria-expanded') === 'false') {
        e.preventDefault();
        
        // Close all other open items first
        mobileHeaderLists.forEach(otherList => {
        if (otherList !== parent && otherList.getAttribute('aria-expanded') === 'true') {
          otherList.setAttribute('aria-expanded', false);
          otherList.style.maxHeight = '1.5rem';
          otherList.style.minHeight = '1.5rem';
        }
        });
        
        // Open the clicked item
        parent.setAttribute('aria-expanded', true);
        parent.style.maxHeight = parent.scrollHeight + 'px';
        parent.style.minHeight = parent.scrollHeight + 'px';
      }
      });
    });

    const mobileTopBar = document.querySelector('.header-mobile');
    const mobileHeaderToggle = document.querySelector('.header__menu-mobile-toggle');
    const mobileNav = document.querySelector('.header-sidebar-nav');
    mobileHeaderToggle.addEventListener('click', () => {
      mobileNav.classList.toggle('active');
      mobileHeaderToggle.classList.toggle('header__menu-mobile-toggle--open');
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('overlay-open');
      document.body.classList.add('overlay-open--left');
      if (!mobileNav.classList.contains('active')) {
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('overlay-open');
        document.body.classList.remove('overlay-open--left');
      }
    });

    //Desktop header functionality
    const header = document.querySelector('.header-desktop');
    const headerPaddingBottom = header.style.paddingBottom || '1.5rem';
    const desktopNav = document.querySelector('.header-desktop');
    const desktopHeaderTabs = desktopNav.querySelectorAll('.header__menu-item');
    const logo = document.querySelector('.header__logo');
    const headerBackground = document.querySelector('.header-desktop--background');
    let headerChildlinkWrapper = null;
    // console.log('desktopheadertabs', desktopHeaderTabs);
    desktopHeaderTabs.forEach(tab => {
      tab.addEventListener('mouseenter', (e) => {
        const linkList = e.target.querySelector('.header__menu-childlinks-wrapper');
        // console.log('element is', e.target);
        // console.log('linklist is', linkList);
        
        if (!linkList) {
          header.style.paddingBottom = headerPaddingBottom; // Reset to default padding
          desktopNav.classList.toggle('header__menu-desktop--open', false);
          if (headerChildlinkWrapper) {
            headerChildlinkWrapper.classList.remove('active');
          }
          
          // Reset background height
          if (headerBackground) {
            headerBackground.style.height = ''; // Remove inline height to let CSS take over
          }
          return;
        } else {
          if (headerChildlinkWrapper) {
            headerChildlinkWrapper.classList.remove('active');
          }
          headerChildlinkWrapper = e.target.querySelector('.header__menu-childlinks-wrapper');
          if (headerChildlinkWrapper) {
            headerChildlinkWrapper.classList.add('active');
          }
          const newPaddingBottom = `calc( ${headerPaddingBottom} + 2.6rem + ${linkList.scrollHeight}px )`;
          header.style.paddingBottom = newPaddingBottom;
          header.setAttribute('active-tab', e.target.querySelector('a.header__menu-link').textContent.trim());
          desktopNav.classList.toggle('header__menu-desktop--open', true);
          
          // Set background height to match header height
          if (headerBackground) {
            // Get current header height including the expanded dropdown
            const headerHeight = header.offsetHeight;
            headerBackground.style.height = `${headerHeight}px`;
          }
        }
      });

      // reset on switching tabs
      header.addEventListener('mouseleave', (e) => {
        header.style.paddingBottom = headerPaddingBottom; // Reset to default padding
        desktopNav.classList.toggle('header__menu-desktop--open', false);
        if (headerChildlinkWrapper) {
          headerChildlinkWrapper.classList.remove('active');
        }
        
        // Reset background height
        if (headerBackground) {
          headerBackground.style.height = ''; // Remove inline height to let CSS take over
        }
      });

      logo.addEventListener('mouseenter', (e) => {
        header.style.paddingBottom = headerPaddingBottom; // Reset to default padding
        desktopNav.classList.toggle('header__menu-desktop--open', false);
        if (headerChildlinkWrapper) {
          headerChildlinkWrapper.classList.remove('active');
        }
        
        // Reset background height
        if (headerBackground) {
          headerBackground.style.height = ''; // Remove inline height to let CSS take over
        }
      });
    });

    //write me a function that adds active to the header tab desktop once scrolling past 20% of the viewport on all pages
    function handleScroll() {
      const scrollPosition = document.querySelector('body').scrollTop;
      const viewportHeight = window.innerHeight;
      const triggerPoint = viewportHeight * 0.15;

      if (scrollPosition > triggerPoint) {
        desktopNav.classList.add('header-desktop--active');
        mobileTopBar.classList.add('header-mobile--active');
      } else {
        desktopNav.classList.remove('header-desktop--active');
        mobileTopBar.classList.remove('header-mobile--active');
      }

      if (scrollPosition < triggerPoint) {
        desktopNav.classList.remove('header-desktop--active');
        mobileTopBar.classList.remove('header-mobile--active');
      }
    }

    document.querySelector('body').addEventListener('scroll', handleScroll);

    // Cart drawer functionality
    const cartDrawer = document.querySelector('cart-drawer');
    const HeaderIcons = document.querySelector('.header__icons');
    const cartHeaderButton = HeaderIcons.querySelector('.icon-cart');

    cartHeaderButton.addEventListener('click', e => {
      // console.log('cart clicked');
      e.preventDefault();
      window.openCart();
    });
  }

  initHeader();
}